module.exports = __webpack_public_path__ + "img/fma-logo.d38113ba.png";